import { useEffect, useState } from "react";
import { t } from "@/i18n-js/instance";
import { BackToOptionsLink } from "@circle-react/components/OnboardingComponents/BackToOptionsLink";
import { ForgotPasswordLink } from "@circle-react/components/OnboardingComponents/ForgotPasswordLink";
import { LoginOptions } from "@circle-react/components/OnboardingComponents/LoginOptions";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { OnboardingLayout } from "@circle-react/components/OnboardingPage/layouts/OnboardingLayout";
import { PageTitle } from "@circle-react/components/OnboardingPage/layouts/PageTitle";
import { SignInForm } from "./SignInForm";
import { SignupLink } from "./SignupLink";

export const SignInPage = () => {
  const pageTitle = t("sign_in");
  const [shouldShowForm, setShouldShowForm] = useState(false);

  const currentHash = window.location.hash;
  const title = t("login_to_your_circle_account");

  useEffect(() => {
    setShouldShowForm(currentHash === "#email");
  }, [currentHash]);

  return (
    <OnboardingLayout
      community={null}
      title={title}
      subtitle={null}
      isNarrow
      withCircleBranding
      shouldShowPoweredByCircle
      isVerticallyCenteredOnMobile
      background="discover"
    >
      <PageTitle title={pageTitle} />
      <div>
        {shouldShowForm ? (
          <SignInForm />
        ) : (
          <LoginOptions
            formUrl={authenticationAppRoutes.discoverSignIn()}
            variant="signin"
          />
        )}
      </div>

      <div className="mt-8 flex flex-col items-center justify-center">
        {shouldShowForm && (
          <BackToOptionsLink url={authenticationAppRoutes.discoverSignIn()} />
        )}
        <SignupLink />
        <ForgotPasswordLink
          url={authenticationAppRoutes.discoverForgotPassword()}
        />
      </div>
    </OnboardingLayout>
  );
};

export default SignInPage;
